const it = {
  meta: {
    home: {
      title: 'Manifestify | App di Manifestazione e Affermazioni',
      description:
        'Manifestify è un\'app di manifestazione e affermazioni quotidiane per iOS e Android. Crea il tuo manifesto personale, fissa intenzioni, componi vision board e decifra i sogni con l\'IA.',
    },
    blog: {
      title: 'Blog Manifestazione: Affermazioni, Guide e Metodi',
      description:
        'Guide esperte su come manifestare: affermazioni quotidiane, metodo 369, vision board, scripting e interpretazione dei sogni. Nuovi articoli dal team di Manifestify.',
    },
    notFound: {
      title: 'Pagina non trovata | Manifestify',
      description: 'La pagina che cerchi non esiste.',
    },
    terms: {
      title: 'Termini e Condizioni | Manifestify',
      description: "I termini e le condizioni d'uso dell'app e del sito Manifestify.",
    },
    privacy: {
      title: 'Informativa sulla Privacy | Manifestify',
      description: 'Come Manifestify raccoglie, usa e protegge i tuoi dati personali.',
    },
  },

  nav: {
    brandAria: 'Home di Manifestify',
    mainAria: 'Navigazione principale',
    blog: 'Blog',
    getApp: "Scarica l'app",
    languageAria: 'Cambia lingua',
    languageLabel: 'Lingua',
  },

  store: {
    downloadOn: 'Scarica su',
    appStore: 'App Store',
    getItOn: 'DISPONIBILE SU',
    googlePlay: 'Google Play',
    appleAria: "Scarica Manifestify sull'App Store",
    googleAria: 'Ottieni Manifestify su Google Play',
  },

  home: {
    hero: {
      titleLine1: 'Manifesta i tuoi sogni, ogni giorno.',
      titleAccent: 'Con Manifestify!',
      subtitle:
        "L'app di manifestazione che tiene viva la tua pratica: affermazioni quotidiane, un manifesto personale, vision board, intenzioni e interpretazione dei sogni con IA, tutto in un unico posto. Ripeti. Credi. Diventa.",
      note: 'Download gratuito · iOS e Android',
    },
    features: {
      titlePre: 'Tutto ciò che ti serve per ',
      titleAccent: 'manifestare',
      titlePost: '',
      subtitle:
        "Un'unica app per tutta la tua pratica, dalla prima affermazione del mattino fino a decifrare il sogno di stanotte.",
      items: [
        {
          title: 'Affermazioni quotidiane',
          text: "Centinaia di affermazioni scritte con cura su amore, denaro, salute, fiducia in sé e pace interiore, recapitate ogni giorno.",
        },
        {
          title: 'Manifesto personale',
          text: 'Trasforma i tuoi obiettivi in un manifesto personale che leggi e rafforzi ogni giorno, così i tuoi sogni restano davanti a te.',
        },
        {
          title: 'Definizione delle intenzioni',
          text: "Fissa intenzioni quotidiane chiare e lascia che l'app ti tenga ancorato a ciò che conta davvero per te.",
        },
        {
          title: 'Vision board',
          text: 'Componi una vision board digitale della vita che stai creando e visualizzala ovunque, in qualsiasi momento.',
        },
        {
          title: 'Interpretazione dei sogni con IA',
          text: "Descrivi il tuo sogno e scopri i suoi messaggi nascosti con analisi profonde potenziate dall'IA.",
        },
        {
          title: 'Carte energetiche',
          text: 'Pesca una carta energetica ogni giorno: un momento di riflessione e una dose fresca di ispirazione.',
        },
        {
          title: 'Promemoria quotidiani',
          text: 'Notifiche delicate negli orari che scegli, così la tua pratica non dipende più dalla memoria o dalla motivazione.',
        },
        {
          title: 'Temi e sfondi',
          text: 'Temi e sfondi bellissimi che rendono la tua pratica personale e ispirante.',
        },
      ],
    },
    how: {
      titlePre: 'Come ',
      titleAccent: 'funziona',
      titlePost: '',
      steps: [
        {
          title: 'Fissa la tua intenzione',
          text: 'Scegli cosa vuoi manifestare e costruisci il tuo manifesto personale da centinaia di affermazioni selezionate.',
        },
        {
          title: 'Pratica ogni giorno',
          text: 'Ripeti le tue affermazioni, visualizza la tua vision board e pesca la tua carta energetica. I promemoria tengono viva la tua serie.',
        },
        {
          title: 'Credi e diventa',
          text: 'Guarda cambiare il tuo focus, la tua fiducia e le tue scelte mentre la pratica si accumula giorno dopo giorno.',
        },
      ],
    },
    blogTeaser: {
      titlePre: "Impara l'arte della ",
      titleAccent: 'manifestazione',
      titlePost: '',
      subtitle: 'Guide e tecniche dal team di Manifestify, scritte per una vera pratica quotidiana.',
      viewAll: 'Vedi tutti gli articoli →',
    },
    faq: {
      titlePre: 'Domande ',
      titleAccent: 'frequenti',
      titlePost: '',
      items: [
        {
          q: "Che cos'è Manifestify?",
          a: "Manifestify è un'app di manifestazione e affermazioni quotidiane per iOS e Android. Riunisce tutta la tua pratica: affermazioni in categorie come amore, carriera, abbondanza e fiducia, un manifesto personale, la definizione delle intenzioni, una vision board, promemoria quotidiani, carte energetiche e interpretazione dei sogni con IA.",
        },
        {
          q: 'Manifestify è gratuita?',
          a: "Sì. Manifestify si scarica e si usa gratuitamente sia sull'App Store sia su Google Play. I piani premium facoltativi sbloccano l'intera libreria di affermazioni e funzioni avanzate come l'interpretazione dei sogni con IA illimitata.",
        },
        {
          q: "Che cos'è la manifestazione?",
          a: "La manifestazione è la pratica di trasformare i tuoi obiettivi in realtà attraverso attenzione focalizzata, credenza positiva e azione costante. Le tecniche includono affermazioni quotidiane, visualizzazione, vision board, scripting e il metodo 369.",
        },
        {
          q: 'Come funzionano le affermazioni quotidiane?',
          a: "Le affermazioni sono brevi frasi positive al presente che ripeti ogni giorno. Nel giro di settimane rimodellano il tuo dialogo interiore e allenano la tua attenzione verso opportunità allineate ai tuoi obiettivi. La costanza è la chiave, ed è per questo che Manifestify include promemoria quotidiani.",
        },
        {
          q: 'Manifestify è disponibile su iPhone e Android?',
          a: "Sì. Manifestify è disponibile per iPhone e iPad sull'App Store e per i dispositivi Android su Google Play.",
        },
        {
          q: "Come funziona l'interpretazione dei sogni con IA?",
          a: 'Descrivi il tuo sogno nell\'app e Manifestify ne analizza simboli, emozioni e temi per darti subito un\'interpretazione profonda, che puoi affinare con il tuo contesto.',
        },
      ],
    },
    download: {
      title: 'Inizia a manifestare oggi',
      text: 'Unisciti a chi inizia ogni mattina con intenzione. Scarica Manifestify gratis e costruisci una pratica che dura.',
    },
  },

  blog: {
    titlePre: 'Il ',
    titleAccent: 'Blog',
    titlePost: ' di Manifestify',
    subtitle:
      "Guide pratiche su manifestazione, affermazioni, visualizzazione e interpretazione dei sogni. Tutto ciò che ti serve per costruire una pratica quotidiana che funziona.",
    schemaName: 'Il Blog di Manifestify',
    schemaDescription:
      'Guide su manifestazione, affermazioni quotidiane, vision board, scripting e interpretazione dei sogni.',
    readTime: '{n} min di lettura',
  },

  post: {
    breadcrumbAria: 'Percorso di navigazione',
    home: 'Home',
    blog: 'Blog',
    ctaTitle: 'Mettilo in pratica con Manifestify',
    ctaText:
      "Affermazioni quotidiane, un manifesto personale, vision board, intenzioni e interpretazione dei sogni con IA. Tutta la tua pratica di manifestazione in un'app gratuita.",
    faqTitle: 'Domande frequenti',
    relatedTitle: 'Continua a leggere',
    relatedAria: 'Articoli correlati',
  },

  notFound: {
    text: 'Questa pagina non esiste, ma i tuoi sogni sì.',
    backHome: 'Torna alla home',
    readBlog: 'Leggi il blog',
  },

  footer: {
    tagline:
      "Manifesta i tuoi sogni, ogni giorno. Affermazioni, intenzioni, vision board e interpretazione dei sogni in un'unica app.",
    exploreTitle: 'Esplora',
    exploreAria: 'Esplora',
    home: 'Home',
    blog: 'Blog',
    downloadTitle: "Scarica l'app",
    downloadAria: 'Download',
    appStoreLink: 'iPhone e iPad (App Store)',
    playStoreLink: 'Android (Google Play)',
    legalTitle: 'Note legali',
    legalAria: 'Note legali',
    terms: 'Termini e Condizioni',
    privacy: 'Informativa sulla Privacy',
    copyright: '© {year} Manifestify di Portal Studio. Tutti i diritti riservati.',
  },

  legal: {
    back: 'Indietro',
    translationNotice:
      "Questa traduzione è fornita per comodità. La versione legalmente vincolante di questo documento è quella inglese.",
    lastUpdated: 'Ultimo aggiornamento: {date}',
  },
};

export default it;
